module.exports = __webpack_public_path__ + "static/media/5-1.16451ff0.mp3";